// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff/api/mfa.proto (package kikoff.api.mfa, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message kikoff.api.mfa.Challenge
 */
export class Challenge extends Message<Challenge> {
  /**
   * @generated from field: kikoff.api.mfa.Challenge.Carrier carrier = 1;
   */
  carrier = Challenge.Carrier.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: uint32 code_length = 3;
   */
  codeLength = 0;

  constructor(data?: PartialMessage<Challenge>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.Challenge";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "carrier", kind: "enum", T: proto3.getEnumType(Challenge.Carrier) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code_length", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Challenge {
    return new Challenge().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Challenge {
    return new Challenge().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Challenge {
    return new Challenge().fromJsonString(jsonString, options);
  }

  static equals(a: Challenge | PlainMessage<Challenge> | undefined, b: Challenge | PlainMessage<Challenge> | undefined): boolean {
    return proto3.util.equals(Challenge, a, b);
  }

  static _enums: {
    Carrier: typeof Challenge.Carrier,
  };
}

export namespace Challenge {
  /**
   * @generated from enum kikoff.api.mfa.Challenge.Carrier
   */
  export enum Carrier {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: PHONE = 1;
     */
    PHONE = 1,

    /**
     * @generated from enum value: EMAIL = 2;
     */
    EMAIL = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Challenge.Carrier)
  proto3.util.setEnumType(Challenge.Carrier, "kikoff.api.mfa.Challenge.Carrier", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "PHONE" },
    { no: 2, name: "EMAIL" },
  ]);
}

/**
 * @generated from message kikoff.api.mfa.ChallengeRequest
 */
export class ChallengeRequest extends Message<ChallengeRequest> {
  /**
   * (Required) and must be anything other than Purpose.UNKNOWN
   *
   * @generated from field: kikoff.api.mfa.ChallengeRequest.Purpose purpose = 1;
   */
  purpose = ChallengeRequest.Purpose.UNKNOWN;

  /**
   * (Optional) If not specified (or Carrier.UNKNOWN) will be auto-selected by the backend
   *
   * @generated from field: kikoff.api.mfa.Challenge.Carrier carrier = 2;
   */
  carrier = Challenge.Carrier.UNKNOWN;

  constructor(data?: PartialMessage<ChallengeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.ChallengeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purpose", kind: "enum", T: proto3.getEnumType(ChallengeRequest.Purpose) },
    { no: 2, name: "carrier", kind: "enum", T: proto3.getEnumType(Challenge.Carrier) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChallengeRequest {
    return new ChallengeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChallengeRequest {
    return new ChallengeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChallengeRequest {
    return new ChallengeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChallengeRequest | PlainMessage<ChallengeRequest> | undefined, b: ChallengeRequest | PlainMessage<ChallengeRequest> | undefined): boolean {
    return proto3.util.equals(ChallengeRequest, a, b);
  }

  static _enums: {
    Purpose: typeof ChallengeRequest.Purpose,
  };
}

export namespace ChallengeRequest {
  /**
   * @generated from enum kikoff.api.mfa.ChallengeRequest.Purpose
   */
  export enum Purpose {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: USER_LOGIN = 1;
     */
    USER_LOGIN = 1,

    /**
     * @generated from enum value: BANK_ORIGINATE_ACH_DEBIT = 2;
     */
    BANK_ORIGINATE_ACH_DEBIT = 2,

    /**
     * @generated from enum value: BANK_ORIGINATE_ACH_CREDIT = 3;
     */
    BANK_ORIGINATE_ACH_CREDIT = 3,

    /**
     * @generated from enum value: USER_PASSWORD_UPDATE = 4;
     */
    USER_PASSWORD_UPDATE = 4,

    /**
     * @generated from enum value: BANK_IN_APP_PROVISIONING = 5;
     */
    BANK_IN_APP_PROVISIONING = 5,

    /**
     * @generated from enum value: ACCOUNT_RECOVERY_PHONE_VERIFICATION = 6;
     */
    ACCOUNT_RECOVERY_PHONE_VERIFICATION = 6,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChallengeRequest.Purpose)
  proto3.util.setEnumType(ChallengeRequest.Purpose, "kikoff.api.mfa.ChallengeRequest.Purpose", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "USER_LOGIN" },
    { no: 2, name: "BANK_ORIGINATE_ACH_DEBIT" },
    { no: 3, name: "BANK_ORIGINATE_ACH_CREDIT" },
    { no: 4, name: "USER_PASSWORD_UPDATE" },
    { no: 5, name: "BANK_IN_APP_PROVISIONING" },
    { no: 6, name: "ACCOUNT_RECOVERY_PHONE_VERIFICATION" },
  ]);
}

/**
 * @generated from message kikoff.api.mfa.ChallengeResponse
 */
export class ChallengeResponse extends Message<ChallengeResponse> {
  /**
   * @generated from field: kikoff.api.mfa.ChallengeResponse.Status status = 1;
   */
  status = ChallengeResponse.Status.UNKNOWN;

  /**
   * Active challenge
   *
   * @generated from field: kikoff.api.mfa.Challenge challenge = 2;
   */
  challenge?: Challenge;

  /**
   * List of other carriers user may try
   *
   * @generated from field: repeated kikoff.api.mfa.Challenge alternatives = 3;
   */
  alternatives: Challenge[] = [];

  /**
   * @generated from field: string challenge_token = 4;
   */
  challengeToken = "";

  /**
   * Only meaningful if status == Status.FAILURE
   *
   * @generated from field: kikoff.api.mfa.ChallengeResponse.Failure.Reason failure_reason = 5;
   */
  failureReason = ChallengeResponse.Failure.Reason.UNKNOWN;

  constructor(data?: PartialMessage<ChallengeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.ChallengeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ChallengeResponse.Status) },
    { no: 2, name: "challenge", kind: "message", T: Challenge },
    { no: 3, name: "alternatives", kind: "message", T: Challenge, repeated: true },
    { no: 4, name: "challenge_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "failure_reason", kind: "enum", T: proto3.getEnumType(ChallengeResponse.Failure.Reason) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChallengeResponse {
    return new ChallengeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChallengeResponse {
    return new ChallengeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChallengeResponse {
    return new ChallengeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChallengeResponse | PlainMessage<ChallengeResponse> | undefined, b: ChallengeResponse | PlainMessage<ChallengeResponse> | undefined): boolean {
    return proto3.util.equals(ChallengeResponse, a, b);
  }

  static _enums: {
    Status: typeof ChallengeResponse.Status,
  };
}

export namespace ChallengeResponse {
  /**
   * @generated from enum kikoff.api.mfa.ChallengeResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILURE = 2;
     */
    FAILURE = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChallengeResponse.Status)
  proto3.util.setEnumType(ChallengeResponse.Status, "kikoff.api.mfa.ChallengeResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILURE" },
  ]);
}

export namespace ChallengeResponse {
  /**
   * @generated from message kikoff.api.mfa.ChallengeResponse.Failure
   */
  export class Failure extends Message<ChallengeResponse.Failure> {
    constructor(data?: PartialMessage<ChallengeResponse.Failure>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff.api.mfa.ChallengeResponse.Failure";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChallengeResponse.Failure {
      return new ChallengeResponse.Failure().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChallengeResponse.Failure {
      return new ChallengeResponse.Failure().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChallengeResponse.Failure {
      return new ChallengeResponse.Failure().fromJsonString(jsonString, options);
    }

    static equals(a: ChallengeResponse.Failure | PlainMessage<ChallengeResponse.Failure> | undefined, b: ChallengeResponse.Failure | PlainMessage<ChallengeResponse.Failure> | undefined): boolean {
      return proto3.util.equals(ChallengeResponse.Failure, a, b);
    }

    static _enums: {
      Reason: typeof ChallengeResponse.Failure.Reason,
    };
  }
}

export namespace ChallengeResponse.Failure {
  /**
   * @generated from enum kikoff.api.mfa.ChallengeResponse.Failure.Reason
   */
  export enum Reason {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: NO_CARRIERS = 1;
     */
    NO_CARRIERS = 1,

    /**
     * @generated from enum value: INVALID_PURPOSE = 2;
     */
    INVALID_PURPOSE = 2,

    /**
     * @generated from enum value: INVALID_CARRIER = 3;
     */
    INVALID_CARRIER = 3,

    /**
     * @generated from enum value: TOO_MANY_ATTEMPTS = 4;
     */
    TOO_MANY_ATTEMPTS = 4,

    /**
     * when user has 0 or more than 1 duplicate(s)
     *
     * @generated from enum value: INVALID_DUPLICATE_ACCOUNT = 5;
     */
    INVALID_DUPLICATE_ACCOUNT = 5,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChallengeResponse.Failure.Reason)
  proto3.util.setEnumType(ChallengeResponse.Failure.Reason, "kikoff.api.mfa.ChallengeResponse.Failure.Reason", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "NO_CARRIERS" },
    { no: 2, name: "INVALID_PURPOSE" },
    { no: 3, name: "INVALID_CARRIER" },
    { no: 4, name: "TOO_MANY_ATTEMPTS" },
    { no: 5, name: "INVALID_DUPLICATE_ACCOUNT" },
  ]);
}

/**
 * @generated from message kikoff.api.mfa.VerifyRequest
 */
export class VerifyRequest extends Message<VerifyRequest> {
  /**
   * @generated from field: string challenge_token = 1;
   */
  challengeToken = "";

  /**
   * @generated from field: string verification_code = 2;
   */
  verificationCode = "";

  constructor(data?: PartialMessage<VerifyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.VerifyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "challenge_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyRequest {
    return new VerifyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyRequest {
    return new VerifyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyRequest {
    return new VerifyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyRequest | PlainMessage<VerifyRequest> | undefined, b: VerifyRequest | PlainMessage<VerifyRequest> | undefined): boolean {
    return proto3.util.equals(VerifyRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff.api.mfa.VerifyResponse
 */
export class VerifyResponse extends Message<VerifyResponse> {
  /**
   * @generated from field: kikoff.api.mfa.VerifyResponse.Status status = 1;
   */
  status = VerifyResponse.Status.UNKNOWN;

  /**
   * Empty unless status is Status.ACCEPTED
   *
   * @generated from field: string verification_proof = 2;
   */
  verificationProof = "";

  constructor(data?: PartialMessage<VerifyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.VerifyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(VerifyResponse.Status) },
    { no: 2, name: "verification_proof", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyResponse {
    return new VerifyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyResponse {
    return new VerifyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyResponse {
    return new VerifyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyResponse | PlainMessage<VerifyResponse> | undefined, b: VerifyResponse | PlainMessage<VerifyResponse> | undefined): boolean {
    return proto3.util.equals(VerifyResponse, a, b);
  }

  static _enums: {
    Status: typeof VerifyResponse.Status,
  };
}

export namespace VerifyResponse {
  /**
   * @generated from enum kikoff.api.mfa.VerifyResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * Verification code is correct, thus verification_proof was generated
     *
     * @generated from enum value: ACCEPTED = 1;
     */
    ACCEPTED = 1,

    /**
     * Verification code is incorrect
     *
     * @generated from enum value: REJECTED = 2;
     */
    REJECTED = 2,

    /**
     * Expired or too many rejected attempts
     *
     * @generated from enum value: INVALID = 3;
     */
    INVALID = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(VerifyResponse.Status)
  proto3.util.setEnumType(VerifyResponse.Status, "kikoff.api.mfa.VerifyResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ACCEPTED" },
    { no: 2, name: "REJECTED" },
    { no: 3, name: "INVALID" },
  ]);
}

/**
 * @generated from message kikoff.api.mfa.TrustRequest
 */
export class TrustRequest extends Message<TrustRequest> {
  /**
   * Only verification proof of USER_LOGIN challenge.
   * Any other challenge purpose will be rejected.
   *
   * @generated from field: string verification_proof = 1;
   */
  verificationProof = "";

  constructor(data?: PartialMessage<TrustRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.TrustRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "verification_proof", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrustRequest {
    return new TrustRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrustRequest {
    return new TrustRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrustRequest {
    return new TrustRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TrustRequest | PlainMessage<TrustRequest> | undefined, b: TrustRequest | PlainMessage<TrustRequest> | undefined): boolean {
    return proto3.util.equals(TrustRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff.api.mfa.TrustResponse
 */
export class TrustResponse extends Message<TrustResponse> {
  /**
   * @generated from field: kikoff.api.mfa.TrustResponse.Status status = 1;
   */
  status = TrustResponse.Status.UNKNOWN;

  constructor(data?: PartialMessage<TrustResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff.api.mfa.TrustResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(TrustResponse.Status) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrustResponse {
    return new TrustResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrustResponse {
    return new TrustResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrustResponse {
    return new TrustResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TrustResponse | PlainMessage<TrustResponse> | undefined, b: TrustResponse | PlainMessage<TrustResponse> | undefined): boolean {
    return proto3.util.equals(TrustResponse, a, b);
  }

  static _enums: {
    Status: typeof TrustResponse.Status,
  };
}

export namespace TrustResponse {
  /**
   * @generated from enum kikoff.api.mfa.TrustResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: ACCEPTED = 1;
     */
    ACCEPTED = 1,

    /**
     * @generated from enum value: REJECTED = 2;
     */
    REJECTED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(TrustResponse.Status)
  proto3.util.setEnumType(TrustResponse.Status, "kikoff.api.mfa.TrustResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ACCEPTED" },
    { no: 2, name: "REJECTED" },
  ]);
}

